<header class="flex header p-2">
  <h2>{{ 'MachineAssignment.preview_title' | translateWF: 'Import Preview' }}</h2>
</header>

<section class="content p-4">
  <!-- Summary stats -->
  <div class="flex mb-4">
    <div class="stat-chip stat-ok">
      <i class="pi pi-check-circle"></i>
      <span>{{ previewResult.totalOk }} {{ 'MachineAssignment.preview_total_ok' | translateWF: 'OK' }}</span>
    </div>
    <div class="stat-chip stat-duplicate">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ previewResult.totalDuplicates }} {{ 'MachineAssignment.preview_total_duplicates' | translateWF: 'Duplicates' }}</span>
    </div>
    <div class="stat-chip stat-missing">
      <i class="pi pi-times-circle"></i>
      <span>{{ previewResult.totalMissingData }} {{ 'MachineAssignment.preview_total_missing' | translateWF: 'Missing Data' }}</span>
    </div>
  </div>

  <!-- Duplicate warning + override toggle -->
  @if (hasDuplicates()) {
    <div class="duplicate-warning mb-4">
      <p-message severity="warn" styleClass="w-full mb-3">
        {{ 'MachineAssignment.preview_duplicate_warning' | translateWF: 'There are duplicate records. Enable override to replace them.' }}
      </p-message>
      <div class="flex align-items-center gap-2">
        <p-toggleswitch [ngModel]="overrideEnabled()" (ngModelChange)="overrideEnabled.set($event)" />
        <label>{{ 'MachineAssignment.preview_override_label' | translateWF: 'Override duplicates' }}</label>
      </div>
    </div>
  }

  <!-- Preview table -->
  <p-table [value]="previewResult.items" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'MachineAssignment.col_status' | translateWF: 'Status' }}</th>
        <th>{{ 'MachineAssignment.col_date' | translateWF: 'Date' }}</th>
        <th>{{ 'MachineAssignment.col_asset' | translateWF: 'Asset' }}</th>
        <th>{{ 'MachineAssignment.col_shift' | translateWF: 'Shift' }}</th>
        <th>{{ 'MachineAssignment.col_employees' | translateWF: 'Employee Codes' }}</th>
        <th>{{ 'MachineAssignment.col_supervisor' | translateWF: 'Supervisor' }}</th>
        <th>{{ 'MachineAssignment.col_group' | translateWF: 'Group' }}</th>
        <th>{{ 'MachineAssignment.col_cost_center' | translateWF: 'Cost Center' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr
        [ngClass]="{
          'row-ok': item.status === 'Ok',
          'row-duplicate': item.status === 'Duplicate',
          'row-missing': item.status === 'MissingData',
        }"
      >
        <td>
          <p-tag [value]="'MachineAssignment.status_' + item.status | translateWF: item.status" [severity]="getStatusSeverity(item.status)" />
        </td>
        <td>{{ formatDate(item.assignment.date) }}</td>
        <td>{{ item.assignment.assetId }}</td>
        <td>
          {{ item.assignment.shift === 0 ? ('MachineAssignment.shift_Matutino' | translateWF: 'Matutino') : ('MachineAssignment.shift_Nocturno' | translateWF: 'Nocturno') }}
        </td>
        <td>{{ item.assignment.employeeCodes.join(', ') }}</td>
        <td>{{ item.assignment.supervisor }}</td>
        <td>{{ getGroupName(item.assignment.groupReference) }}</td>
        <td>{{ item.assignment.costCenterCode ?? '-' }}</td>
      </tr>
    </ng-template>
  </p-table>
</section>

<footer>
  <p-button [label]="'MachineAssignment.preview_cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
  <p-button [label]="'MachineAssignment.preview_save' | translateWF: 'Save'" severity="success" icon="pi pi-check" [disabled]="!canSave()" (click)="onConfirm()" />
</footer>
